import React from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import formatValue from "../../../../../../Utils/ListUtils/FormatValue";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {red} from "@material-ui/core/colors";
import JsonScreenHoc from "../../../../../../HocHelpers/JsonScreenHoc";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: 5
    },
    commentContainer: {
        padding: '0 5px',
        position: 'relative',
        '&:hover': {
            background: '#fbfbfb',
            '& $reply': {
                visibility: 'visible'
            },
            '& $deleteComment': {
                visibility: 'visible'
            }
        }
    },
    replyContainer: {
        margin: '0px 0px 10px 0px',
        display: 'flex',
        position: 'relative'
    },
    reply: {
        visibility: 'hidden',
        fontSize: '0.8rem',
        margin: '0 10px',
        '&:hover': {
            textDecoration: 'underline',
            color: theme.palette.primary.main,
            cursor: 'pointer'
        }
    },
    deleteComment: {
        visibility: 'hidden',
        position: 'absolute',
        top: 10,
        right: 10
    },
    avatar: {
        backgroundColor: red[500],
        width: 30,
        height: 30
    },
    title: {
        paddingLeft: 10,
        flexGrow: 1
    },
    headText: {
        fontSize: '0.9rem',
        lineHeight: 1.1
    },
    commentHeader: {
        padding: '5px 10px',
        display: 'flex',
        alignItems: 'center'
    }
}));

const Comment = JsonScreenHoc((props) => {
    const {author, message, created, deleted, replyComment, onClickReply, onClickDelete, globalValues} = props;
    const classes = useStyles();
    return (
        <div className={classes.commentContainer}>
            <CommentHeader
                author={author}
                created={created}
            />
            <CommentContent
                deleted={deleted}
                message={message}
                replyComment={replyComment}
            />
            {!deleted && (
                <CommentReply
                    onClick={onClickReply}
                />
            )}
            {globalValues.session.user.id === author._id && (
                <div className={classes.deleteComment}>
                    <IconButton style={{padding: 0}} size={"small"} onClick={onClickDelete} disabled={deleted}>
                        <Icon fontSize={"small"}>
                            clear
                        </Icon>
                    </IconButton>
                </div>
            )}
        </div>
    )
});
Comment.propTypes = {
    author: PropTypes.string,
    created: PropTypes.string,
    message: PropTypes.string,
    deleted: PropTypes.bool,
    replyRef: PropTypes.string
};


const CommentHeader = ({author, created}) => {
    const classes = useStyles();
    return (
        <div className={classes.commentHeader}>
            <Avatar aria-label="recipe" className={classes.avatar}>
                {author.name.charAt(0).toUpperCase()}
            </Avatar>
            <div className={classes.title}>
                <Typography className={classes.headText} autoCapitalize>
                    {author.name}
                </Typography>
                <Typography color={"textSecondary"} className={classes.headText}>
                    {formatValue(created, 'datetime')}
                </Typography>
            </div>
        </div>
    )
};
CommentHeader.defaultProps = {
    author: ''
};
const CommentContent = ({message, deleted, replyComment}) => {
    const classes = useStyles();
    return (
        <div style={{padding: '0 10px'}}>
            {!deleted && replyComment.message && (
                <div className={classes.replyContainer}>
                    <Typography
                        color={"textPrimary"}
                        style={{
                            fontSize: '0.9rem',
                            background: 'rgb(229 229 229)',
                            padding: '10px 20px 10px 5px',
                            position: 'relative'
                        }}
                        component={'span'}
                    >
                        <Typography color={"textSecondary"}
                                    component={'span'}
                                    style={{fontSize: '0.9rem'}}
                        >{replyComment.author ? replyComment.author.name : 'user'}:</Typography> {replyComment.message.slice(0, 50) + "...."}
                    </Typography>
                </div>
            )}
            {deleted ? (
                <Typography color={'textSecondary'} style={{padding: '5px 0'}}>
                    The message has been deleted by user or administrator
                </Typography>
            ) : (
                <Typography className={classes.text}>
                    {message || 'No Message'}
                </Typography>
            )}
        </div>
    )
};
const CommentReply = ({onClick}) => {
    const classes = useStyles();
    return (
        <div className={classes.replyContainer}>
            <Typography className={classes.reply} color={'textSecondary'} component={'span'}
                        onClick={onClick}
            >
                Reply
            </Typography>
        </div>
    )
};

const NoCommentsMessage = () => {
    return (
        <Typography style={{textAlign: 'center', padding: '50px 0'}} color={'textSecondary'}>
            No Comments
        </Typography>
    )
};

export {
    Comment,
    NoCommentsMessage
}